import SocialIconsContainer from './SocialIconsContainer';

export default SocialIconsContainer;
